import { Dialog } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CloseButton } from "../dispatching-planning/common/close-button";
import "./SaveFavoriteLocationDialog.scss";
import { SearchOption } from "./PlaceSearchWithSavedLocations";
import { AutoSuggestItem } from "dora-shared";
import DeliveryLocationForm from "../DeliveryLocationForm";

const SaveDeliveryAddressToEconomicDialog = ({
  onClose,
  location,
  clientId,
}: {
  onClose: (saved: boolean) => void;
  /**
   * The place-search result to prefill from. When omitted the dialog opens
   * blank with its own place search, since coordinates are required either
   * way before saving.
   */
  location?: SearchOption;
  clientId: string;
}) => {
  const { t } = useTranslation(["modals"]);

  return (
    <Dialog open onClose={() => onClose(false)}>
      <div className="save-favorite-location__first-row">
        <div>{t("modals:saveDeliveryAddress.title")}</div>
        <CloseButton onClick={() => onClose(false)} />
      </div>
      <DeliveryLocationForm
        clientId={clientId}
        prefill={
          location ? (location.value.data as AutoSuggestItem) : undefined
        }
        onSaved={() => onClose(true)}
        onCancel={() => onClose(false)}
      />
    </Dialog>
  );
};

export default SaveDeliveryAddressToEconomicDialog;
